<script>
	import TopMenu 			from './TopMenu.svelte'
	import Switcher 		from './Switcher.svelte'
	import Section 			from './Section.svelte'
	import SlidingSection 	from './SlidingSection.svelte'
	import Card 		    from './Card.svelte'
    import Plans            from './Plans.svelte'
    import GetInTouch       from './GetInTouch.svelte'
    import Footer           from './Footer.svelte'

	let iw = 0

	$: cls 	  = iw < 500 ? 'tiny' : iw < 1200 ? 'small' : 'large'
	$: height = iw < 1200 ? '730px' : '500px'

</script>
<style>
    .pt3 {
        padding-top: 3em;
    }

	.api .img {
		width: 220px;
		height: 200px;
		margin: 0 auto;
		background: #38a0ff;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 4px;
	}

    :global(main:not(.large)) .pt3 {
        padding-top: 0;
	}
</style>
<svelte:window bind:innerWidth={iw}/>
<main class={cls}>
	<TopMenu/>
	
	<!-- HERO -->
	<Section classname="basic">
		<div slot="left">
			<h1>Dogma, uma plataforma de gestão de privacidade para sua empresa e para DPOs.</h1>
			<p class="text">
				Atenda aos pedidos dos titulares, 
				faça gestão de consentimentos e cookies, 
				tudo de maneira fácil para atender às necessidades da LGPD.
			</p>
			<div class="pt3">
				<!-- <button class="our secondary blue">Para os Titulares</button> -->
				<button class="our secondary blue">Para sua Empresa</button>
				<button class="our secondary blue">Para o DPO</button>
			</div>
		</div>
		<div slot="right">
			<img class="sshot" src="/img/hero.png" alt="hero">
		</div>
	</Section>

	<!-- Central da Privacidade -->
	<Section classname="basic purple">
		<div slot="left" style="padding-right: 1em;">
			<h1 class="pt3">Central de Privacidade</h1>
			<h2>Um canal de atendimento online para seus titulares</h2>
			<p class="text">
				A Central de Privacidade permite aos titulares da LGPD 
				consentir ou revogar com os tratamentos de dados pessoais ou cookies,
				além de permitir e gerancia a solicitação de pedidos de acesso, retificação e remoção de dados
			</p>
		</div>
		<div slot="right">
			<img class="sshot" src="/img/central_privacidade.svg" alt="central de privacidade"/>
		</div>
	</Section>

	<!-- Cookies -->
	<SlidingSection height={height}>
		<div class="hmax" slot="user">
			<Section classname="blue">
				<div slot="left" class="reverse">
					<div>
						<Switcher to="dpo" />
					</div>
					<div>
						<h1>Cookies</h1>
						<h2>Colete o consentimento para o uso de cookies no seu site</h2>
						<p>
							Na Dogma os cookies são agrupados entre cookies obrigatórios e cookies opcionais.
							É fácil informar seus usuários sobre quais cookies são utilizados pelo seu site e qual a finalidade de cada um
						</p>
					</div>
				</div>
				<div slot="right">
					<img class="sshot" src="/img/cookies.svg" alt="cookies"/>
				</div>
			</Section>
		</div>
		<div class="hmax" slot="dpo">
			<Section classname="purple">
				<div slot="left" class="reverse">
					<div><Switcher to="user" /></div>
					<div>
						<h1>Cookies</h1>
						<p>
							Basta cadastrar os cookies utilizados pelo site
						</p>					
					</div>
				</div>
				<div slot="right">
					<img class="sshot" src="/img/cookies_dpo.svg" alt="cookies"/>
				</div>
			</Section>
		</div>
	</SlidingSection>

	<!-- Consentimentos -->
	<SlidingSection height={height}>
		<div class="hmax" slot="user">
			<Section classname="secondary blue">
				<div slot="left" class="reverse">
					<div><Switcher to="dpo" /></div>
					<div>
						<h1>Consentimentos</h1>
						<h2>Faça a gestão de consentimentos de forma simples, fácil e integrada</h2>
						<p>
							A central de privacidade da Dogma permite que os usuários do seu site configurem 
							as opções de consentimento de forma unificada. 
							<br/>
							Os consentimentos são coletados pela nossa plataforma 
							e estão disponíveis para o DPO ou via API.
						</p>
					</div>				
				</div>
				<div slot="right">
					<img class="sshot" src="/img/consentimentos.svg" alt="consentimentos"/>
				</div>
			</Section>
		</div>
		<div class="hmax" slot="dpo">
			<Section classname="purple">
				<div slot="left" class="reverse">
					<div><Switcher to="user" /></div>
					<div>
						<h1>Consentimentos</h1>
						<p>
							Informe os tratamentos para os quais o consentimento é necessário
						</p>
					</div>
				</div>
				<div slot="right">
					<img class="sshot" src="/img/consentimentos_dpo.svg" alt="consentimentos dpo"/>
				</div>
			</Section>
		</div>
	</SlidingSection>

	<!-- Pedidos -->
	<SlidingSection height={height}>
		<div class="hmax" slot="user">
			<Section classname="blue">
				<div slot="left" class="reverse">
					<div><Switcher to="dpo" /></div>
					<div>
						<h1>Pedidos dos Titulares</h1>
						<h2>Pedidos de acesso, remoção e retificação</h2>
						<p>
							Receba os pedidos dos titulares e entregue o relatório final de execução de forma prática e segura
						</p>
					</div>
				</div>
				<div slot="right">
					<img class="sshot" src="/img/pedidos.svg" alt="pedidos"/>
				</div>
			</Section>
		</div>
		<div class="hmax" slot="dpo">
			<Section classname="purple">
				<div slot="left" class="reverse">
					<div><Switcher to="user" /></div>
					<div>
						<h1>Pedidos dos Titulares</h1>
						<h2>Simplificando uma tarefa complexa</h2>
						<p>
							Desde o início do pedido, até a entrega do relatório final, 
							a Dogma gerencia o processo passo a passo de forma assistida ou automatizada.
						</p>
					</div>
				</div>
				<div slot="right">
					<img class="sshot" src="/img/pedidos_dpo.svg" alt=""/>
				</div>
			</Section>
		</div>
	</SlidingSection>

	<section class="api">
		<div class="middle cards">
			<div class="card">
				<h1>API</h1>
				<div class="img">
					<img src="/img/api.svg" alt="api"/>
				</div>
				<p class="text">
					Não gostou da nossa Central de Privacidade? Não tem problema.
				</p>
				<p class="text">
					Toda funcionalidade da Dogma está disponível via API!
				</p>
				<div style="flex: 1"></div>
				<a class="button purple" href="#getintouch">Fale Conosco</a>
			</div>
			<div class="card">
				<h1>Automação</h1>
				<div class="img">
					<img src="/img/automation.svg" alt="automação"/>
				</div>
				<p class="text">
					O atendimentos dos pedidos dos titulares podem ser 100% automatizados, 
					mas você pode começar com o processo manual. 
				</p>
				<p class="text">
					Tenha tranquilidade para automatizar o que for necessário no momento que você quiser
				</p>
				<div style="flex: 1"></div>
				<a class="button purple" href="https://console.dogma.legal/">Começe Já</a>
			</div>
			<div class="card">
				<h1>Integrações</h1>
				<div class="img">
					<img src="/img/integration.svg" alt="integrações"/>
				</div>
				<p class="text">
					A Dogma pode estar integrada com os sistemas da sua empresa e de terceiros. 
					A api de integração é simples e fácil de usar
				</p>
				<div style="flex: 1"></div>
				<a class="button purple" href="#getintouch">Fale Conosco</a>
			</div>
		</div>
	</section>

	<!-- Data Mapping -->
	<SlidingSection height={height}>
		<div class="hmax" slot="user">
			<Section classname="purple">
				<div slot="left">
					<h1>Inventário de Dados</h1>
					<h2>Uma visão unificada sobre o tratamento de dados pessoais</h2>
					<p>
						Saiba exatamente quais dados pessoais são utilizados e quais as finalidades. 
						Localize rapidamente os dados pessoais dos titulares para responder à pedidos de acesso ou remoção
					</p>
				</div>
				<div slot="right">
					<img class="sshot" src="/img/inventario.svg" alt="inventatio"/>
				</div>
			</Section>
		</div>
	</SlidingSection>

	<!-- Uma Ferramenta Só -->
	<SlidingSection height={height}>
		<div class="hmax" slot="user">
			<Section classname="blue">
				<div slot="left">
					<h1>Gestão unificada</h1>
					<h2>Uma ferramenta só para gestão de vários empresas e sites</h2>
					<p>
						Com a Dogma é possível gerenciar múltiplas empresas e sites com uma única ferramenta.
						Eficiência e produtividade na gestão de dados pessoais
					</p>
				</div>
				<div slot="right">
					<img class="sshot" src="/img/dominios.svg" alt="dominios"/>
				</div>
			</Section>
		</div>
	</SlidingSection>

    <Plans></Plans>
    <GetInTouch></GetInTouch>
    <Footer></Footer>
</main>

	<!-- Template -->
	<!-- <SlidingSection height={height}>
		<div class="hmax" slot="user">
			<Section classname="blue">
				<div slot="left">
					<Switcher to="dpo" />
					<h1>Title</h1>
					<h2>Subtitle</h2>
					<p>Text</p>
				</div>
				<div slot="right">
					<img class="sshot" src="/img/.svg" alt=""/>
				</div>
			</Section>
		</div>
		<div class="hmax" slot="dpo">
			<Section classname="purple">
				<div slot="left">
					<Switcher to="user" />
					<h1>Title</h1>
					<h2>Subtitle</h2>
					<p>Text</p>
				</div>
				<div slot="right">
					<img class="sshot" src="/img/.svg"  alt=""/>
				</div>
			</Section>
		</div>
	</SlidingSection> -->
